// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1Jb4r","modalForm":"UpgradeEpcsModal_modalForm__2q7lu","modalFooter":"UpgradeEpcsModal_modalFooter__3EhD1"};